import React from 'react';
import { Button, Space, Grid } from 'antd';
import {AudioOutlined, PauseOutlined, ThunderboltOutlined} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

export default function RecordingActions({
                                           recordingModalState,
                                           isFinalizing,
                                           isStarting,
                                           onStart,
                                           onPause,
                                           onResume,
                                           onFinalize,
                                         }) {
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const isMobile = screens.xs;
  const buttonStyle = isMobile ? { width: '100%' } : {};

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
      {recordingModalState === 'initial' && (
        <Button
          key="start"
          data-testid="start-recording-button"
          type="primary"
          size="large"
          disabled={isStarting}
          icon={ <AudioOutlined />}
          onClick={onStart}
        >
          { isStarting ? t('recording_modal.starting') : t('recording_modal.start')}
        </Button>
      )}

      {recordingModalState === 'recording' && (
        <Button
          key="pause"
          data-testid="pause-recording-button"
          size={ screens.xs? "middle" : "large"}
          onClick={onPause}
          icon={<PauseOutlined />}>
          {t('recording_modal.pause')}
        </Button>
      )}

      {recordingModalState === 'paused' && (
        <Space direction={screens.xs ? "vertical" : "horizontal"} size="middle" style={screens.xs ? { width: '100%' } : {}}>
          <Button
            key="resume"
            data-testid="resume-recording-button"
            size="large"
            onClick={onResume}
            icon={<AudioOutlined />}
            style={buttonStyle}>
            {t('recording_modal.resume')}
          </Button>

          <Button
            key="finalize"
            data-testid="finalize-recording-button"
            size="large"
            type="primary"
            onClick={onFinalize}
            disabled={isFinalizing}
            icon={<ThunderboltOutlined />}
            style={buttonStyle}
          >
            {t('recording_modal.finalize')}
          </Button>
        </Space>
      )}
    </div>
  );
}